import { render, staticRenderFns } from "./SymbolSvg.vue?vue&type=template&id=1579bfc6&lang=pug&"
import script from "./SymbolSvg.vue?vue&type=script&lang=js&"
export * from "./SymbolSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports